import { Routes } from '@angular/router';
import { AuthPage } from '@mnz-modules/login/pages/auth/auth.page';
import { ChooseAccountPage } from '@mnz-modules/login/pages/choose-account/choose-account.page';
import { LostCredentialsPage } from '@mnz-modules/login/pages/lost-credentials/lost-credentials.page';
import { ActivateAccountPage } from '@mnz-modules/login/pages/activate-account/activate-account.page';
import { LogoutPage } from '@mnz-modules/login/pages/logout/logout.page';
import { SamlPage } from '@mnz-modules/login/pages/saml/saml.page';

export const loginRoutes: Routes = [
  {
    path: '',
    component: ChooseAccountPage,
    pathMatch: 'full',
  },
  {
    path: 'account-activeren/:account',
    component: ActivateAccountPage,
  },
  {
    path: 'account-activeren',
    component: ActivateAccountPage,
  },
  {
    path: 'inloggen/:account',
    component: AuthPage,
  },
  {
    path: 'inlog-vergeten/:account',
    component: LostCredentialsPage,
  },
  {
    path: 'logout',
    component: LogoutPage,
  },
  {
    path: 'saml/sso',
    component: SamlPage,
  },
];
